import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import './IndustryDetail.css';
import { industries, caseStudies, services } from '../data/site';

const IndustryDetail = () => {
  const { id } = useParams();
  const industry = industries.find((i) => i.id === id);

  if (!industry) return <Navigate to="/industries" replace />;

  const relatedCases = caseStudies.filter((cs) => cs.industry.toLowerCase().includes(industry.name.split(' ')[0].toLowerCase())).slice(0, 3);
  const fallbackCases = caseStudies.slice(0, 3);
  const cases = relatedCases.length > 0 ? relatedCases : fallbackCases;

  return (
    <div className="industry-detail-page page-shell">
      <section className="id-hero section-dark">
        <div className="site-container-wide id-hero-grid">
          <div>
            <Link to="/industries" className="id-back">← All industries</Link>
            <span className="section-eyebrow">Industry</span>
            <h1>{industry.name}</h1>
            <p>{industry.summary}</p>
            <div className="hero-actions">
              <Link to="/request-demo" className="btn-primary-large">Book consultation</Link>
              <Link to="/case-studies" className="btn-ghost btn-arrow">Industry outcomes</Link>
            </div>
          </div>
          <div className="hero-video-frame">
            <div className="frame-glow" />
            <img src={industry.image} alt={industry.name} />
            <span className="play-pill">DALYTIX INDUSTRY VIEW</span>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="site-container-wide id-content-grid">
          <div>
            <span className="section-eyebrow">Where we focus</span>
            <h2>The challenges our {industry.name.toLowerCase()} clients are solving in 2026.</h2>
            <ul className="id-list">
              {industry.challenges.map((c) => (<li key={c}>{c}</li>))}
            </ul>

            <h3>Outcomes we have delivered</h3>
            <div className="id-outcomes">
              {industry.outcomes.map((o) => (
                <div className="id-outcome-card" key={o}>
                  <strong>{o.split(' ')[0]}</strong>
                  <span>{o.split(' ').slice(1).join(' ')}</span>
                </div>
              ))}
            </div>

            <h3>How we engage</h3>
            <p>
              Most {industry.name.toLowerCase()} engagements begin with a 4-week diagnostic to align
              executives on the right outcome, the right architecture, and the sequence. That diagnostic
              becomes a multi-quarter delivery program owned by your team — with senior Dalytix engineers
              embedded inside it.
            </p>
          </div>

          <aside className="id-aside">
            <div className="id-card">
              <h3>Talk to a partner</h3>
              <p>Senior {industry.name.toLowerCase()} partners are available for a 30-minute discovery call.</p>
              <Link to="/contact" className="btn-primary">Get in touch</Link>
            </div>
            <div className="id-card">
              <h4>Recommended services</h4>
              <ul className="id-related">
                {services.slice(0, 5).map((s) => (
                  <li key={s.id}><Link to={`/services/${s.id}`}>{s.title} →</Link></li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </section>

      <section className="section id-cases section-dark">
        <div className="site-container-wide">
          <div className="section-head-row">
            <div>
              <span className="section-eyebrow">Outcomes</span>
              <h2 className="section-title">Recent {industry.name.toLowerCase()} outcomes.</h2>
            </div>
            <Link to="/case-studies" className="btn-ghost btn-arrow">All case studies</Link>
          </div>
          <div className="id-cases-grid">
            {cases.map((cs) => (
              <Link to={`/case-studies/${cs.id}`} className="id-case-card glass-card" key={cs.id}>
                <img src={cs.image} alt={cs.title} />
                <span className="eyebrow-tag">{cs.industry}</span>
                <h3>{cs.title}</h3>
                <strong>{cs.metric}</strong>
                <span>{cs.metricLabel}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default IndustryDetail;
